import React from 'react';

import withIntl from 'hoc/withIntl';
import ErrorBoundary from './ErrorBoundary';

const IntlWrappedErrorBoundary = withIntl(ErrorBoundary);
export default IntlWrappedErrorBoundary;

export const errorBoundaryWrapper = (ReactComponent, { includeIntl } = {}) => {
  const ErrorBoundaryWrappedComponent = props => {
    const Wrapper =
      includeIntl === false ? ErrorBoundary : IntlWrappedErrorBoundary;

    return (
      <Wrapper>
        <ReactComponent {...props} />
      </Wrapper>
    );
  };

  ErrorBoundaryWrappedComponent.displayName = `errorBoundaryWrapper(${ReactComponent.displayName})`;

  return ErrorBoundaryWrappedComponent;
};
